import CodeEditor from './CodeEditor'

export default CodeEditor
